document.addEventListener('DOMContentLoaded', function() {
  const fileUpload = document.getElementById('artwork-file-upload');
  const removeFileButton = document.getElementById('remove-artwork-file');
  const fileNameDisplay = document.getElementById('file-name-display');

  fileUpload.addEventListener('change', function() {
    if (fileUpload.files.length > 0) {
      removeFileButton.style.display = 'inline-block'; // Show the remove button
    } else {
      fileNameDisplay.textContent = '';
      removeFileButton.style.display = 'none'; // Hide the remove button
    }
  });

  removeFileButton.addEventListener('click', function() {
    fileUpload.value = ''; // Clear the selected file
    removeFileButton.style.display = 'none'; // Hide the remove button
  });
});